import { SegmentedControl, Text } from '@mantine/core'
import { IconBuildingStore, IconLayoutList, IconSchool } from '@tabler/icons'
import { useRouter } from 'next/router'
import React from 'react'

import { modules } from '@/lib/utils/siteModules'
import { useSiteContext } from '@/providers/SiteContextProvider'
import { SiteModule as SiteModuleType } from '@/types'

interface Props {
  size?: 'xs' | 'sm' | 'md'
  fullWidth?: boolean
  onChange?: () => void
}

const MODULE_ICONS = { store: <IconBuildingStore />, enrollment: <IconSchool /> }

export default function ContextSwitcher({ size = 'sm', fullWidth, onChange }: Props) {
  // Hooks
  const router = useRouter()
  const { activeContext, setActiveContext, hasMultipleModules, isContextReady, isModulesReady } =
    useSiteContext()

  // Actions
  const handleChange = (value: string) => {
    const selected = value as SiteModuleType

    onChange?.()
    setActiveContext(selected)

    router.push(modules[selected].homePath)
  }

  if (!isModulesReady || !isContextReady || !hasMultipleModules || !activeContext) return null

  return (
    <SegmentedControl
      color="custom"
      size={size}
      radius="md"
      fullWidth={fullWidth}
      value={activeContext}
      onChange={handleChange}
      data={(Object.keys(modules) as SiteModuleType[]).map(key => ({
        value: key,
        label: (
          <Text
            color={activeContext === key ? 'white' : 'inherit'}
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            {MODULE_ICONS[key] || <IconLayoutList />}
            <strong>{modules[key].label}</strong>
          </Text>
        )
      }))}
    />
  )
}
